/**
 * Serializes a status-filter selection for the contact-detail activity tabs
 * (Email History, Sequences, Automations).
 *
 * The backend distinguishes three cases and so must the wire format:
 * `undefined` (param omitted) means "no filter", `''` means every box was
 * unchecked and matches nothing, and a comma-joined list narrows to it. Each
 * endpoint parses the value with a comma-split `@Transform`.
 */
export function toStatusFilterParam(statuses: readonly string[] | undefined): string | undefined {
    return statuses ? statuses.join(',') : undefined;
}
